import '../style.css';
import { mountDrawingRelay } from './game';

mountDrawingRelay();
